import { render, staticRenderFns } from "./ChannelValidation.vue?vue&type=template&id=b360542c&"
import script from "./ChannelValidation.vue?vue&type=script&lang=js&"
export * from "./ChannelValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports